

































import { defineComponent } from "@vue/composition-api";
import {
  BlockLabel,
  getBlockKey,
  getBlockKeys,
  getBlockLabel,
  blocksWithoutDuplicates,
  illegalBlockCombinationList,
  onlyValidInContingentBlocks,
} from "@/models/BlockLabel";
import { Getters } from "@/store";
import { mapGetters } from "vuex";
import { CalculationBlock } from "@/models/Calculation";

export default defineComponent({
  name: "BlockChooser",
  props: {
    isContingent: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      blockKeys: getBlockKeys(),
    };
  },
  computed: {
    ...mapGetters([Getters.OPEN_CALCULATION]),
  },
  methods: {
    getLabel: (blockKey: string) => getBlockLabel(blockKey),
    choose(blockKey: string, dialog: any) {
      dialog.value = false;
      this.$emit("addBlock", blockKey);
    },
    isBlockDisabled(blockKey: string) {
      const isBlockInCalculation = this.openCalculation.blocks.some(
        (x: CalculationBlock) => x.type === blockKey
      );

      const isIllegalDuplicate =
        isBlockInCalculation &&
        blocksWithoutDuplicates.some(
          (x: BlockLabel) => getBlockKey(x) === blockKey
        );

      if (isIllegalDuplicate) return true;

      for (const illegalBlockCombination of illegalBlockCombinationList) {
        const isBlockInSet = illegalBlockCombination.some(
          (block) => getBlockKey(block) == blockKey
        );
        if (!isBlockInSet) continue;

        const hasOpenBlockInSet = this.openCalculation.blocks.some(
          (openBlock: CalculationBlock) =>
            illegalBlockCombination.some(
              (block) => getBlockKey(block) == openBlock.type
            )
        );
        if (hasOpenBlockInSet) return true;
      }

      const isDisabledWithThisCalculationType =
        this.isContingent == false &&
        onlyValidInContingentBlocks.some(
          (x: BlockLabel) => getBlockKey(x) === blockKey
        );
      if (isDisabledWithThisCalculationType) return true;

      return false;
    },
  },
});
